import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root',
})

export class ShowArchiveTbMappingsCommandHandler implements IPlatformCommandHandler {
  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private particleCacheService: ParticleCacheService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const sourceType = handler.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const showArchived = command.isChecked;
    handler.magicLinkModel.tabBar.tabs[handler.magicLinkModel.tabBar.selectedIndex].tabData['SHOW_ARCHIVED'] = showArchived;
    const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
    params['SHOW_ARCHIVED'] = command.isChecked;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType, params);
    handler.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
    return true;
  }
}